import { useState } from "react";
import { X, Gift, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import api from "../lib/api";
import { toast } from "sonner";

const LeadCapturePopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setSubmitting(true);
    try {
      await api.post("/leads/newsletter", { email, name, source: "popup" });
      setSubmitted(true);
      toast.success("Welcome! Check your email for your free guide.");
      setTimeout(() => onClose(), 3000);
    } catch (error) {
      setSubmitted(true);
      toast.success("You're on the list!");
      setTimeout(() => onClose(), 3000);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
        <div className="bg-surface border border-platinum/20 rounded-lg p-8 shadow-2xl max-w-md w-full text-center animate-fade-in">
          <div className="w-16 h-16 rounded-full bg-emerald/20 flex items-center justify-center mx-auto mb-4">
            <Gift className="text-emerald" size={32} />
          </div>
          <h3 className="text-2xl font-serif text-slate-900 mb-2">You're In!</h3>
          <p className="text-platinum/70">Check your inbox for your free Investor Verification Guide.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-surface border border-platinum/20 rounded-lg shadow-2xl max-w-lg w-full relative animate-fade-in overflow-hidden">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-platinum/50 hover:text-platinum z-10"
        >
          <X size={24} />
        </button>
        
        <div className="grid md:grid-cols-5">
          {/* Left accent */}
          <div className="hidden md:block md:col-span-2 bg-burgundy/20 p-6">
            <div className="h-full flex flex-col justify-center">
              <Gift className="text-burgundy mb-4" size={48} />
              <h4 className="text-cream font-serif text-lg mb-2">Free Guide</h4>
              <p className="text-platinum/60 text-sm">
                "5 Steps to Complete the Approved Regulated Partner Onboarding Pathway"
              </p>
            </div>
          </div>
          
          {/* Form */}
          <div className="md:col-span-3 p-8">
            <h3 className="text-2xl font-serif text-slate-900 mb-2">
              Begin Your Verification
            </h3>
            <p className="text-platinum/60 mb-6">
              Get our free guide to the introducer, KYC, and regulated-partner onboarding flow.
            </p>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="text"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="bg-white border-slate-200 text-slate-900"
              />
              <Input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-white border-slate-200 text-slate-900"
              />
              <Button 
                type="submit"
                disabled={submitting}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white shadow-sm"
              >
                {submitting ? "Sending..." : "Get Free Guide"}
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </form>
            
            <p className="text-platinum/40 text-xs mt-4 text-center">
              No spam. Unsubscribe anytime.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadCapturePopup;
